import moment from 'moment';

export function hasDateTimePassed(
  dateTimeStr: string,
  durationInMinutes: number,
): boolean {
  // Parse the input date-time string
  const givenDateTime = new Date(dateTimeStr);

  // Validate if the date is valid
  if (isNaN(givenDateTime.getTime())) {
    throw new Error('Invalid date-time format.');
  }

  // Add duration to the given date-time
  const endDateTime = new Date(
    givenDateTime.getTime() + durationInMinutes * 60000,
  );

  // Compare with current date-time
  const currentDateTime = new Date();

  return currentDateTime > endDateTime;
}

export const generateTimeOptions = (): string[] => {
  return Array.from({ length: 24 }).flatMap((_, i) => {
    const hour = i % 12 === 0 ? 12 : i % 12;
    const ampm = i < 12 ? 'AM' : 'PM';

    return [
      `${hour.toString().padStart(2, '0')}:00 ${ampm}`,
      `${hour.toString().padStart(2, '0')}:30 ${ampm}`,
    ];
  });
};

export const convertTo24Hour = (time12h: string): string => {
  if (!time12h) return '';

  return moment(time12h, ['h:mm A', 'hh:mm A']).format('HH:mm');
};

export const convertTo12Hour = (time24h: string): string => {
  if (!time24h) return '';

  return moment(time24h, 'HH:mm').format('hh:mm A');
};

// ICON-4946: inactivity auto-logoff timing — session times out after 15 minutes of inactivity.
export const IDLE_TIMEOUT_MS = 15 * 60 * 1000;
// How long before the timeout to show the "you're about to be logged out" flash notification, and how long that notification stays up.
export const IDLE_PROMPT_BEFORE_IDLE_MS = 30 * 1000;
